// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'
import Cookies from 'js-cookie'
import svg from './partials/svg.js'
import owlCarousel from 'owl.carousel';

//(document).foundation();

$(document).ready(function($) {
  svg();

  $('.go-to-form').click(function (){
    $('html, body').animate({
      scrollTop: $("#form").offset().top
    }, 'slow');
    return false;
  });

  $('.open-takeout').click(function(){
    $('.overlay').fadeIn();
    return false;
  });

  function getFormattedDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  if ($('#closedModal').length > 0) {
    $('.overlay').fadeIn();    
    
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    console.log(formattedDate)

    Cookies.set("closed-today", formattedDate);
  } 

  // if(Cookies.get('takeout') !== 'viewed') {
  //   $('.overlay').show();
  //   Cookies.set('takeout', 'viewed');    
  // }

  $('.overlay .close-button, .overlay .overlay-bg').click(function(){
    $('.overlay').fadeOut();
  });

  // mobile menu
  $('.menu-button').click(function(){
    $('.mobile-menu').fadeIn();
  });
  $('.close-menu').click(function(){
    $('.mobile-menu').fadeOut();
  });

  $(".cookies-close").click(function () {
    Cookies.set('cookies-accepted', 'yes', { expires: 31 });
    $(".cookies-regulation").animate({bottom:-150},500).fadeOut();
    return false;
  });

  // recommendations carousel for homepage
  $('.owl-carousel').owlCarousel({
    loop: true,
    items: 1,
    margin: 10,
    nav: false,
    stageClass: 'owl-stage row align-middle',
    autoplay: true,
    autoplayTimeout:5000,
    autoplayHoverPause: true,
    //dotsData: true,
  });

  $(".owl-carousel .owl-dots .owl-dot").each(function(index){
    $(this).find('span').text(index + 1);
  });

  if($('figure a').length > 0) {
    $('figure a').simpleLightbox();
  }

  // menu page tabs
  if ($('#menu-tabs').length > 0) {
    $('#menu-tabs a').on('click', function (event) {
      event.preventDefault();

      if($(this).hasClass('is-active')) {
        return false;
      }

      let hash = $(this).attr('href');
      hash = hash.replace( /^#/, '' );

      var node = $( '#' + hash );
      if ( node.length ) {
        node.attr( 'id', '' );
      }
      document.location.hash = hash;
      if ( node.length ) {
        node.attr( 'id', hash );
      }
      
      $('.tabs-content .is-active').removeClass('is-active');    
      $('#menu-tabs .is-active').removeClass('is-active');
      $(this).parent().addClass('is-active');
      $('.tabs-content div').removeClass('is-active');  
      $($(this).attr('href')).addClass('is-active');
    });

    if (window.location.hash) {
      let hash = window.location.hash;
      $('#menu-tabs a[href*="'+ hash +'"]').click();
    }
  }

  // forms checkboxes and radios
  $( document ).on( 'nfFormReady' , function() {
    $('.content .posts input[type="checkbox"]').each(function(){
      $(this).parent().addClass('pretty p-svg p-default p-smooth')
      $(this).after('<div class="state"><label></label></div>')
      $('.checkbox.svg').clone().appendTo($(this).next().children())
    });
    
    $('input[type="radio"]').each(function(){
      $(this).parent().addClass('pretty p-default p-round p-smooth')
      $(this).after('<div class="state"><label></label></div>')
    });
    svg();
  });

  // Set default consent configuration to 'denied'
  function setDefaultConsentConfig() {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('consent', 'default', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
      });
    }
  }

  function sendMarketingConsent(readFromCookies) {
    console.log('sendMarketingConsent called', { readFromCookies });
    
    let consentMarketingStorage, consentAnalyticsStorage;

    if (readFromCookies) {
      consentMarketingStorage = getCookieValue('cmplz_marketing') === 'allow';
      consentAnalyticsStorage = getCookieValue('cmplz_statistics') === 'allow';
      console.log('Reading consent from cookies', { consentMarketingStorage, consentAnalyticsStorage });
    } else {
      consentMarketingStorage = $('#cmplz-marketing-optin').is(':checked');
      consentAnalyticsStorage = $('#cmplz-statistics-optin').is(':checked');
      console.log('Reading consent from checkboxes', { consentMarketingStorage, consentAnalyticsStorage });
    }

    const consentData = {
      functionality_storage: true,
      analytics_storage: consentAnalyticsStorage,
      marketing_storage: consentMarketingStorage,
      ad_user_data: consentMarketingStorage
    };

    // Push consent data to dataLayer
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        'event': 'marketingConsent',
        'consentData': consentData
      });
    } else {
      console.log('dataLayer not defined, retrying in moment');
      setTimeout(() => sendMarketingConsent(readFromCookies), 300);
    }

    // Update consent configuration for Google tags
    if (typeof window.gtag !== 'undefined') {
      window.gtag('consent', 'update', {
        ad_storage: consentMarketingStorage ? 'granted' : 'denied',
        analytics_storage: consentAnalyticsStorage ? 'granted' : 'denied',
      });
    }
  }

  function getCookieValue(name) {
    const nameString = name + "=";
    const value = document.cookie.split(';').find(item => item.trim().startsWith(nameString));
    return value ? decodeURIComponent(value.split('=')[1]) : null;
  }

  $('body').on('click', '.cmplz-accept', function(){
    $('#cmplz-marketing-optin').prop('checked', true);
    $('#cmplz-statistics-optin').prop('checked', true);
    sendMarketingConsent(false);
  });

  $('body').on('click', '#cmplz-cookiebanner-container button:not(".cmplz-view-preferences")', function(){
    console.log('Consent button clicked');
    sendMarketingConsent(false);
  });

  setDefaultConsentConfig();
  sendMarketingConsent(true);

  // const observer = new MutationObserver((mutations, obs) => {
  //   const gaScript = document.querySelector('script[src*="googletagmanager.js"]');
  //   if (gaScript) {
  //     console.log('manager ')
  //     sendMarketingConsent();
  //     obs.disconnect(); // Stop observing once GA is found
  //   }
  // });
  
  // observer.observe(document.head, {childList: true, subtree: true});
  
  $( document ).on( 'nfFormSubmitResponse', function() {
    //Do Stuff
    let title = $('h1').first().text(); 

    if (typeof gtag === 'function') {    
      window.dataLayer = window.dataLayer || [];

      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-CL6QZ3VE0Z');
      
      gtag('event', 'form_sent', {
        'event_label': 'form_sent',
        'value': title
      });
    }
  });

});

$('.newsletter_form').submit(function(e){
  var nonce = $('.newsletter_form .nonce').val();
  var email = $('.newsletter_form .email').val();
  var gdpr = $('.newsletter_form .gdpr').val();

  $('#mce-success-response').hide();

  $.ajax({
    type: 'POST',
    url: Ajax.ajax.url,
    data: {
      action: 'subscribe_to_mailjet',
      nonce: nonce,
      email: email,
      gdpr: gdpr,
    },
    success: function(result) {
      $('#responses').html( result ).show();
    },
    error: function(errorThrown){
      console.log(errorThrown);
    } 
  });

  e.preventDefault();
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js